export const minDelayInMs = 15000;
export const maxDelayInMs = 20000;
export const maxRefetchDistance = 100;
export const refetchDistanceInterval = 10000
